import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Container,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Alert,
  CircularProgress,
  Chip,
} from '@mui/material';
import { CheckCircle, Refresh } from '@mui/icons-material';
import { publicPaybosAPI } from '../services/paybosService';

const PaybosPaymentSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('id') || searchParams.get('payment_id');
  const [status, setStatus] = useState<string>('PENDING');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const checkStatus = async () => {
    if (!paymentId) {
      setError('ID pembayaran tidak ditemukan di URL');
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const res = await publicPaybosAPI.getPaymentDetail(paymentId);
      if (res.success) {
        setStatus(res.data.status);
      } else {
        setError(res.message || 'Pembayaran tidak ditemukan');
      }
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkStatus();
    const interval = setInterval(() => {
      if (status === 'PENDING') checkStatus();
    }, 30000);
    return () => clearInterval(interval);
  }, [paymentId, status]);

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Card>
        <CardContent sx={{ textAlign: 'center' }}>
          {loading ? (
            <CircularProgress />
          ) : error ? (
            <Alert severity="error">{error}</Alert>
          ) : (
            <Box>
              {status === 'PAID' ? (
                <CheckCircle color="success" sx={{ fontSize: 64, mb: 2 }} />
              ) : null}
              <Typography variant="h5" gutterBottom>
                {status === 'PAID' ? 'Pembayaran Berhasil' : 'Menunggu Pembayaran'}
              </Typography>
              <Chip label={status} color={status === 'PAID' ? 'success' : 'warning'} sx={{ mb: 2 }} />
              {status === 'PENDING' && (
                <Box>
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Pembayaran belum terkonfirmasi. Halaman ini akan memperbarui status secara otomatis.
                  </Alert>
                  <Button startIcon={<Refresh />} onClick={checkStatus}>Perbarui Status</Button>
                </Box>
              )}
            </Box>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default PaybosPaymentSuccessPage;
